import { documentTypesLocales } from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import { UploadableDocumentType } from './types';

const libDocumentTypesLocales = new LocalizedStrings(documentTypesLocales);
const getLibraryBasedLocales = (documentType: UploadableDocumentType) => {
  const { label: documentName } = libDocumentTypesLocales[documentType];
  return { documentName };
};
export default getLibraryBasedLocales;
